'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('./SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _helpers = require('../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collection_Header = function Collection_Header(_ref) {
	var meta = _ref.meta,
	    index = _ref.index,
	    selected = _ref.selected;
	var name = meta.name,
	    version = meta.version,
	    author_name = meta.author_name,
	    author_url = meta.author_url,
	    license_name = meta.license_name,
	    license_url = meta.license_url,
	    is_premium = meta.is_premium,
	    prices = meta.prices,
	    identifier = meta.identifier,
	    type = meta.type;


	var total = selected.filter(function (el) {
		// console.log(el.iconset_id , index, el.iconset_id == index);
		return el.iconset_id == index;
	}).length;

	var tooltip = '';
	var url = '';

	var premium = is_premium;

	if (type === 'local') {
		premium = false;
	}

	// License Text & URL
	var license_text = '';
	if (license_name !== void 0) {
		if (license_url !== void 0) {
			license_text = _react2.default.createElement(
				'li',
				null,
				iconPressConfig.translations.LICENSE,
				': ',
				_react2.default.createElement(
					'a',
					{ href: (0, _helpers.referrize)(license_url), target: '_blank' },
					license_name
				)
			);
		} else {
			license_text = _react2.default.createElement(
				'li',
				null,
				iconPressConfig.translations.LICENSE,
				': ',
				license_name
			);
		}
	}

	return _react2.default.createElement(
		'div',
		{ className: 'ip-collectionHeader' },
		_react2.default.createElement(
			'div',
			{ className: 'ip-collectionHeader-title' },
			_react2.default.createElement(
				'span',
				{ className: 'ip-chTitle' },
				name
			),
			_react2.default.createElement(
				'span',
				{ className: 'ip-chTitle-count' },
				' ',
				_react2.default.createElement(
					'span',
					{ className: 'ip-totalIcons-highlight' },
					total
				),
				' ',
				iconPressConfig.translations.ICONS_SELECTED
			)
		),
		_react2.default.createElement(
			'ul',
			{ className: 'ip-collectionHeader-info' },
			version && _react2.default.createElement(
				'li',
				null,
				'v',
				version
			),
			author_name !== void 0 && author_url !== void 0 && _react2.default.createElement(
				'li',
				null,
				iconPressConfig.translations.BY,
				' ',
				_react2.default.createElement(
					'a',
					{ href: (0, _helpers.referrize)(author_url), target: '_blank' },
					author_name
				)
			),
			license_text
		)
	);
};

exports.default = Collection_Header;


//////////////////
// WEBPACK FOOTER
// ./src/components/Collection_Header.js
// module id = 258
// module chunks = 0 1